module.exports = __webpack_public_path__ + "assets/bloqhouse.708f2385.svg";